<template>
  <BuiEntityListingPage
    v-bind="listNamesConfig"
    :ItemsLister="PlayersLister"
    :hideDefaultTitle="true"
    :customTitle="'Register'"
    :singleSelect="false"
    :MetaDataOptionsComponent="MetaDataOptions"
    :itemsListerBind="{ buiColumns: playersColumns }"
    :createItemPage="canCreate"
    @create="createDialog?.openModal()"
  />

  <!-- Register Player modal — Phase 3 create-modal template (see PlaylistsListView).
       The nested Select Location dialog stacks above this one: both are
       z-[10000] Headless UI dialogs and the later-mounted nested dialog wins
       (Phase 1 stacking convention, bug 1.3). -->
  <Dialog ref="createDialog" panelClass="bui-dialog-panel">
    <template #dialog.title>Register Player</template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <CreatePlayerForm @cancel="closeModal" @success="closeModalAfter(1000)" />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import BuiEntityListingPage from '@/components/bui/organisms/EntityListingPage';
import Dialog from '@/components/Dialog/Dialog.vue';
import CreatePlayerForm from './CreatePlayerForm/CreatePlayerForm.vue';
import PlayersLister from './PlayersLister/PlayersLister.vue';
import MetaDataOptions from './MetaDataOptions/MetaDataOptions.vue';
import listNamesConfig from "./PlayersLister/config/listNames.config";
import playersColumns from "./PlayersLister/config/tableColumns.config";
import useUser from '@/composables/user';

const user = useUser();
const createDialog = ref();
const canCreate = computed(() => user.hasCreateAccessToArea(listNamesConfig.areaAccessName));
</script>

<style lang="scss" scoped>
</style>
